import { Check, WorkspacePremium } from "@mui/icons-material";
import useCategory from "../utils/useCategory";
import useCart from "../utils/useCart";

export default function Product({children, product}){

    const category = useCategory();

    const { cart, setCart } = useCart();

    const active = cart.product === product?.id;

    const handleClick = () => {
        setCart({ product: active ? null : product.id, session: null});
    }

    return (
        <div 
            className="apply-option" 
            style={active ? {borderColor: category.color} : null}
            onClick={handleClick}
        >

            {active && 
                <div className="apply-option-top" style={{backgroundColor: category.color, color: 'white'}}>
                    <Check sx={{fontSize: 22}} />
                    <span>Sélectionné</span>
                </div>
            }

            {(!active && product.variant.id === 'dpc-pi') &&
            
                <div className="apply-option-top apply-reco">
                    <WorkspacePremium sx={{fontSize: 22}} />
                    <span>Recommandé</span>
                </div>
            }

            {(!active && product.variant.id !== 'dpc-pi') &&
            
                <div className="apply-option-top"></div>
            }

            {children}

        </div>

    );
}